export default function isTherapeute(store) {
  var user = store.getters["user/user"];
  return user.therapeute == true;
}
